import React from 'react';
import Button from '@web-common/components/UI/Button';
import { getIn18Text } from 'api';
const CloseButton = (props) => {
    const { id, innerCloseTab } = props;
    const closeCk = () => {
        innerCloseTab(String(id));
    };
    return (React.createElement(Button, { btnType: "minorGray", size: "small", inline: true, onClick: closeCk }, getIn18Text('GUANBI')));
};
export default CloseButton;
